import ajaxRequest from '../../helpers/ajaxRequest';
import { API } from '../../types';
import {
  initNotificationChannelsSelector,
  invalidFormFieldLabelPositionHandler,
  bindInputServerValidationOnChange,
  validateField,
  HIDE_CLASS
} from './utils';

function getAccountActivated(param): Promise<{ message: string }[]> {
  return ajaxRequest({
    method: 'GET',
    url: API.RESEND_ACTIVATION_EMAIL,
    data: { login: param }
  });
}

function bindNotActivatedAccount(): void {
  const el = document.getElementById('requestForAnotherEmailError');
  el?.addEventListener('click', () => {
    const messageContainer = document.getElementById('notActivatedAccountMessage');
    getAccountActivated(el.dataset.login)
      .then((response) => {
        if (messageContainer) {
          messageContainer.innerHTML = response[0]?.message;
        }
      })
      .catch((errorResponse) => {
        if (typeof errorResponse.then === 'function') {
          errorResponse.then((errors) => {
            if (messageContainer) {
              messageContainer.innerHTML = errors[0].message;
            }
          });
        }
      });
  });
}

function bindMyAccountNavigationOnChange(): void {
  document.querySelector<HTMLSelectElement>('.my-account-nav__select')?.addEventListener('change', (e) => {
    if (e.target && (e.currentTarget as HTMLSelectElement).value) {
      window.location.href = (e.currentTarget as HTMLSelectElement).value;
    }
  });
}

function onFormSubmit(inputsToValidate: NodeListOf<HTMLInputElement>) {
  return (e: Event): boolean => {
    let valid = true;
    inputsToValidate.forEach((el) => {
      const isFieldValid = el.checkValidity() && (el.hasAttribute('required') ? !!el.value : true);
      if (!isFieldValid) {
        validateField(el, true)(e);
        valid = false;
      }
    });
    if (!valid) {
      e.preventDefault();
    }
    return valid;
  };
}

// TODO: move all validation logic to a generic helper class/module
function initFormValidation(): void {
  const forms = document.querySelectorAll<HTMLElement>(
    '.my-account form, .my-account-login form, .my-account-register form'
  );

  forms.forEach((form) => {
    const formId = form.id;

    if (formId) {
      invalidFormFieldLabelPositionHandler(`#${formId}`);
      bindInputServerValidationOnChange(formId);
      const inputsToValidate = form.querySelectorAll<HTMLInputElement>('*[required], *[pattern]');

      form.addEventListener('submit', onFormSubmit(inputsToValidate));

      inputsToValidate.forEach((input) => {
        input.addEventListener('invalid', validateField(input));
        input.addEventListener('change', validateField(input));
      });
    }
  });

  document.querySelectorAll('#addressForm input').forEach((el) => el.dispatchEvent(new CustomEvent('keyup')));
  document.querySelectorAll('#updateEmailForm input').forEach((el) => el.dispatchEvent(new CustomEvent('keyup')));
}

function initLoadMore(): void {
  const btn = document.querySelector<HTMLElement>('.js-load-more-addresses');
  if (!btn) {
    return;
  }

  btn.addEventListener('click', () => {
    btn.remove();
    document.querySelectorAll<HTMLElement>('.js-address-book-item').forEach((el) => {
      el.classList.remove(HIDE_CLASS);
    });
  });
}

export default function initMyAccount(): void {
  bindMyAccountNavigationOnChange();
  initFormValidation();
  bindNotActivatedAccount();
  initLoadMore();
  initNotificationChannelsSelector();
}
